import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';

import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogOverlay,
  AlertDialogPortal,
} from '@/components/ui/alert-dialog';
import { t } from '@/utils/i18n';
import { cn } from '@/lib/utils';

interface UnsavedChangesDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirmLeave: () => void;
}

export const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
  isOpen,
  onClose,
  onConfirmLeave,
}) => {
  useLanguage();
  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <AlertDialogPortal>
        {/* Overlay com desfoque e z-index máximo para ficar na frente de tudo */}
        <AlertDialogOverlay className="backdrop-blur-sm bg-black/10 !z-[9999]" />

        {/* Modal com largura reduzida e z-index máximo */}
        <AlertDialogContent className="w-[92vw] sm:w-[420px] sm:max-w-[420px] !z-[10000]">
          <AlertDialogHeader>
            <AlertDialogTitle>{translateInterfaceText("Tem certeza que deseja sair?")}</AlertDialogTitle>
            <AlertDialogDescription>
              {translateInterfaceText("As alterações não salvas serão perdidas.")}</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="w-auto px-3 h-9 rounded-lg text-[13px] font-medium border-border text-muted-foreground hover:bg-muted hover:text-[#64748b] transition-colors">
              {translateInterfaceText("Cancelar")}</AlertDialogCancel>
            <AlertDialogAction
              onClick={onConfirmLeave}
              className="w-auto px-3 h-9 rounded-lg text-[13px] font-medium bg-red-500 hover:bg-red-600"
            >
              {translateInterfaceText("Sair")}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogPortal>
    </AlertDialog>
  );
};
